import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AccessControlService {
    private authService = inject(AuthService);

    /**
     * Gets the current user's role.
     */
    getCurrentUserRole(): string | null {
        const user = this.authService.user();
        return user ? user.role : null;
    }

    /**
     * Checks if the current user has the specified role.
     */
    hasRole(role: string): boolean {
        const userRole = this.getCurrentUserRole();
        return userRole === role;
    }

    /**
     * Checks if the current user has any of the specified roles.
     */
    hasAnyRole(roles: string[]): boolean {
        const userRole = this.getCurrentUserRole();
        if (!userRole) return false;
        return roles.includes(userRole);
    }
}
